import { cn } from '@/package';

const style = {
  tickerList: cn('relative h-full w-full overflow-x-auto overflow-y-hidden'),
  tickerListContainer: cn('flex h-full flex-1 overflow-visible text-body-sm'),
  tickerListContainerThresholder: cn('h-full min-w-1'),
  tickerListGrap: cn(
    'flex items-center justify-center',
    'absolute top-[1px] left-[var(--left)]',
    'bg-white',
    'rounded-full border-[5px] border-blue-300 hover:border-primary-400 active:border-primary-400',
    'z-10 size-[5px] translate-x-[var(--transformX)]',
    'box-content',
    'shadow-sm',
  ),
  tickerListGroup: cn(
    'relative',
    'mt-1',
    'h-2',
    'w-[var(--width)]',
    'bg-gray-200',

    'nth-last-[2]:w-2',
    'nth-[2]:rounded-tl-full nth-[2]:rounded-bl-full',
    'nth-last-[2]:rounded-tr-full nth-last-[2]:rounded-br-full',
  ),
  tickerListGroupPreloaded: cn(
    'after:block after:content-[""]',
    'after:flex-1',
    'after:h-full',
    'after:bg-gray-300',
  ),
  tickerListGroupItem: cn(
    'relative',
    // 'w-[var(--width)]'
    'h-full w-2 cursor-pointer flex-col items-start justify-end select-none',
    'rounded-tl-full rounded-bl-full',

    'before:absolute before:top-0.5 before:left-0.5',
    'before:size-1',
    'before:rounded-full before:bg-white',
    'before:content-[""]',
  ),
  tickerListGroupItemAssignedMe: cn('before:!bg-gray-400'),
  tickerListGroupItemPreloaded: cn('bg-gray-300'),
  tickerListGroupItemText: cn('absolute top-3'),
  tickerListGroupItemTextEm: cn('font-semibold text-black'),
  tickerListGroupItemTextBoundary: cn('text-blue-300'),
  tickerListGroupItemTextOuter: cn('opacity-25'),
  tickerListGroupItemOtherText: cn('text-gray-300'),
} as const;

export default style;
